"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentTemplateService = void 0;
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("./base.service");
var api_constants_1 = require("../constants/api.constants");
var serializers_1 = require("./serializers");
var constants_1 = require("../constants");
var AssessmentTemplateService = /** @class */ (function (_super) {
    __extends(AssessmentTemplateService, _super);
    function AssessmentTemplateService(options, assessmentClient, assessmentSerializer) {
        var _this = _super.call(this, options) || this;
        _this.assessmentTemplateClient = assessmentClient;
        _this.assessmentTemplateSerializer = assessmentSerializer;
        return _this;
    }
    AssessmentTemplateService.newInstance = function (options) {
        return new AssessmentTemplateService(options, insync_assess_sdk_1.AssessmentTemplateClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), new serializers_1.AssessmentTemplateSerializer());
    };
    AssessmentTemplateService.prototype.findOne = function (assessmentTemplateId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.findOne(assessmentTemplateId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, this.assessmentTemplateSerializer.serialize(data)];
                }
            });
        });
    };
    AssessmentTemplateService.prototype.findByExternalId = function (externalId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.findByExternalId(externalId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, this.assessmentTemplateSerializer.serialize(data)];
                }
            });
        });
    };
    /**
     * Find all assessment templates by owner
     * @param {string[]} status
     * @param {string[]} sort
     * @param {PageableOptions} pageableOptions
     * @returns {Promise<AssessmentTemplate[]>}
     *
     * @example
     * findByOwner({status:['published'],assignmentType:['TQ'],curriculum:['em'],grade:['1'],
     * ['key,asc', 'otherKey,desc'], shared:true,owned:false}, limit: 20, skip: 10)
     */
    AssessmentTemplateService.prototype.findByOwner = function (filters_1) {
        return __awaiter(this, arguments, void 0, function (filters, limit, skip, curriculumId) {
            var pageable;
            var _this = this;
            if (limit === void 0) { limit = 100; }
            if (skip === void 0) { skip = 0; }
            if (curriculumId === void 0) { curriculumId = constants_1.CurriculumId.EurekaMath; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.findByOwner(filters, { limit: limit, skip: skip }, this.getDefaultHeaders({ curriculumId: (filters === null || filters === void 0 ? void 0 : filters.curriculum) ? filters.curriculum[0] : curriculumId }))];
                    case 1:
                        pageable = _a.sent();
                        return [2 /*return*/, pageable.data.map(function (dto) {
                                return _this.assessmentTemplateSerializer.serialize(dto);
                            })];
                }
            });
        });
    };
    AssessmentTemplateService.prototype.findByStandard = function (standardGlobalId_1) {
        return __awaiter(this, arguments, void 0, function (standardGlobalId, limit, skip, curriculumId) {
            var pageable;
            var _this = this;
            if (limit === void 0) { limit = 100; }
            if (skip === void 0) { skip = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.findByStandard(standardGlobalId, { limit: limit, skip: skip }, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        pageable = _a.sent();
                        return [2 /*return*/, pageable.data.map(function (dto) {
                                return _this.assessmentTemplateSerializer.serialize(dto);
                            })];
                }
            });
        });
    };
    /**
     * Publish an assessment template base on id provided
     * @param {string} assessmentTemplateId   - Assessment Template id
     */
    AssessmentTemplateService.prototype.publish = function (assessmentTemplateId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.publish(assessmentTemplateId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Copy an Assessment Template
     * @param {string} assessmentTemplateId   - Assessment Template id
     */
    AssessmentTemplateService.prototype.copy = function (assessmentTemplateId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            var assessmentTemplateCopy;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.copy(assessmentTemplateId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        assessmentTemplateCopy = _a.sent();
                        return [2 /*return*/, this.assessmentTemplateSerializer.serialize(assessmentTemplateCopy)];
                }
            });
        });
    };
    /**
     * Sync an assessment template base on external id provided
     * @param {string} externalId   - External assessment Template id
     */
    AssessmentTemplateService.prototype.sync = function (externalId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.sync(externalId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Rename an assessment template
     * @param {string} assessmentTemplateId   - Assessment Template id
     * @param {string} title                  - new title
     */
    AssessmentTemplateService.prototype.rename = function (assessmentTemplateId, title, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.rename(assessmentTemplateId, title, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a custom assessment template
     * @param {CustomAssessmentTemplateDto} assessmentTemplate   - Assessment Template
     */
    AssessmentTemplateService.prototype.createCustom = function (assessmentTemplate) {
        return __awaiter(this, void 0, void 0, function () {
            var assessmentTemplateDto;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.createCustom(assessmentTemplate, this.getDefaultHeaders({ curriculumId: assessmentTemplate.curriculum }))];
                    case 1:
                        assessmentTemplateDto = _a.sent();
                        return [2 /*return*/, this.assessmentTemplateSerializer.serialize(assessmentTemplateDto)];
                }
            });
        });
    };
    /**
     * Create a custom assessment template
     * @param {CreateAssessmentTemplateDto} assessmentTemplate   - Assessment Template
     */
    AssessmentTemplateService.prototype.editCustom = function (assessmentTemplateId, customAssessmentTemplate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.updateCustom(assessmentTemplateId, customAssessmentTemplate, this.getDefaultHeaders({ curriculumId: customAssessmentTemplate.curriculum }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all assignment types based on the curriculum
     * @param {string} curriculumId   - Curriculum ID to search assignment types for
     */
    AssessmentTemplateService.prototype.findAssignmentTypesByCurriculum = function (curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.findAssignmentTypesByCurriculum(curriculumId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an assessment template
     * @param {string}      assessmentTemplateId
     */
    AssessmentTemplateService.prototype.delete = function (assessmentTemplateId, curriculumId) {
        return this.assessmentTemplateClient.delete(assessmentTemplateId, this.getDefaultHeaders({ curriculumId: curriculumId }));
    };
    /**
     * Returns a new AssessmentTemplate with standards in each item
     * @param {assessmentTemplate} assessmentTemplates
     * @param {itemStandards[]} itemStandards[]
     * @returns {assessmentTemplate}
     */
    AssessmentTemplateService.prototype.mergeAssessmentTemplatesStandards = function (assessmentTemplate, itemStandards) {
        if (itemStandards === void 0) { itemStandards = []; }
        assessmentTemplate.items.forEach(function (item) {
            var _a;
            var standards = (_a = itemStandards.find(function (itemStandard) { return itemStandard.externalItemId === item.externalId; })) === null || _a === void 0 ? void 0 : _a.standardGlobalIds;
            item.standards = standards || [];
        });
        return assessmentTemplate;
    };
    /**
     * Share an assessment template with teachers
     * @param {string}      assessmentTemplateId
     * @param {string[]}      userIds
     */
    AssessmentTemplateService.prototype.share = function (assessmentTemplateId, userIds, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.assessmentTemplateClient.share(assessmentTemplateId, userIds, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Activate an assessment template
     * @param {string}      assessmentTemplateId
     */
    AssessmentTemplateService.prototype.activate = function (assessmentTemplateId, curriculumId) {
        return this.assessmentTemplateClient.activate(assessmentTemplateId, this.getDefaultHeaders({ curriculumId: curriculumId }));
    };
    /**
     * Deactivate an assessment template
     * @param {string}      assessmentTemplateId
     */
    AssessmentTemplateService.prototype.deactivate = function (assessmentTemplateId, curriculumId) {
        return this.assessmentTemplateClient.deactivate(assessmentTemplateId, this.getDefaultHeaders({ curriculumId: curriculumId }));
    };
    return AssessmentTemplateService;
}(base_service_1.BaseService));
exports.AssessmentTemplateService = AssessmentTemplateService;
